import { runClientComponent } from '../../_common/client/client-component-runner';
import { ImagesComponent } from './images.component';

import '../../_feature-components/zoom-image';

runClientComponent({ ImagesComponent });
